import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchPortfolioHealth } from "../../DealerInsights/services/api";
import "../../../styles/dashboardCardTokens.css";
import "./LotPerformanceCard.css";

const DEFAULT_COUNTS = { elite: 0, strong: 0, watch: 0, risk: 0 };

function getCountsFromApi(data) {
  if (!data?.bucket_counts) return null;
  const b = data.bucket_counts;
  return {
    elite: b.ELITE?.count ?? 0,
    strong: b.STRONG?.count ?? 0,
    watch: b.WATCH?.count ?? 0,
    risk: b.RISK?.count ?? 0,
  };
}

export default function LotPerformanceCard() {
  const [counts, setCounts] = useState(DEFAULT_COUNTS);

  useEffect(() => {
    fetchPortfolioHealth()
      .then((data) => {
        const next = getCountsFromApi(data);
        if (next) setCounts(next);
      })
      .catch(() => {});
  }, []);

  const maxCount = Math.max(
    counts.elite,
    counts.strong,
    counts.watch,
    counts.risk,
    1
  );

  const rows = [
    {
      key: "elite",
      label: "Elite",
      value: counts.elite,
      barClass: "lpBar lpBar-elite",
    },
    {
      key: "strong",
      label: "Strong",
      value: counts.strong,
      barClass: "lpBar lpBar-strong",
    },
    {
      key: "watch",
      label: "Watch",
      value: counts.watch,
      barClass: "lpBar lpBar-watch",
    },
    {
      key: "risk",
      label: "Risk",
      value: counts.risk,
      barClass: "lpBar lpBar-risk",
    },
  ];

  return (
    <section className="lpCard dashboard-card-base" aria-label="Lot Performance">
      <header className="lpHeader">
        <h3 className="lpTitle">Lot Performance</h3>
      </header>

      <div className="lpBars">
        {rows.map((row) => (
          <Link
            key={row.key}
            className="lpRow"
            to={`/dealer-insights?bucket=${row.key}`}
          >
            <span className="lpLabel">{row.label}</span>
            <div className="lpBarWrap">
              <div
                className={row.barClass}
                style={{
                  width: `${(row.value / maxCount) * 100}%`,
                  minWidth: row.value > 0 ? "8px" : 0,
                }}
              />
            </div>
            <span className="lpValue">{row.value}</span>
          </Link>
        ))}
      </div>

      <footer className="lpFooter">
        <Link className="lpLink" to="/dealer-insights">
          Open Lot Performance <span className="lpChevron">→</span>
        </Link>
      </footer>
    </section>
  );
}
